export const ARTICLE_TYPE = "Article";
export const PHOTO_TYPE = "Photo";
export const VIDEO_TYPE = "Video";
export const AUDIO_TYPE = "Audio";

export const contentTypes = [ARTICLE_TYPE, PHOTO_TYPE, VIDEO_TYPE, AUDIO_TYPE];